const validations = {
  title: {
    required: true,
    minLength: 2,
  },
};

export { validations };
